import clsx from 'clsx';
import { Popover, PopoverGroup } from '@/design-system';
import { LANGUAGE_NAMES, LOCALES, ns, useT } from '@/i18n';
import type { Currency } from '@/services/domain';
import { useOverlays } from '../state/overlays';
import { usePreferences } from '../state/preferences';
import styles from './PreferencesPopover.module.css';

// Arabic is hidden until the site is translated (Decisions 20, 75): only the locales of src/i18n are offered.
const CURRENCIES: Currency[] = ['MAD', 'EUR', 'USD'];

/** Language and currency picker. */
export function PreferencesPopover() {
  const t = useT(ns.shell);
  const overlays = useOverlays();
  // The picker shows the visitor's choice (the prices follow the effective currency, MAD when its rate is missing).
  const { language, selectedCurrency, setLanguage, setCurrency } = usePreferences();
  return (
    <Popover open={overlays.current === 'preferences'} onClose={overlays.close} label={t('preferences')}>
      <PopoverGroup>{t('prefs.language')}</PopoverGroup>
      <div className={styles.opts} role="radiogroup" aria-label={t('prefs.language')}>
        {LOCALES.map((code) => (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={language === code}
            className={clsx(language === code && styles.on)}
            onClick={() => setLanguage(code)}
          >
            {LANGUAGE_NAMES[code]}
            <small>{code.toUpperCase()}</small>
          </button>
        ))}
      </div>
      <PopoverGroup>{t('prefs.currency')}</PopoverGroup>
      <div className={styles.opts} role="radiogroup" aria-label={t('prefs.currency')}>
        {CURRENCIES.map((code) => (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={selectedCurrency === code}
            className={clsx(selectedCurrency === code && styles.on)}
            onClick={() => setCurrency(code)}
          >
            {code}
            <small>{t(`prefs.${code}`)}</small>
          </button>
        ))}
      </div>
      <p className={clsx('t-small t-muted', styles.note)}>{t('prefs.note')}</p>
    </Popover>
  );
}
